// extracted by mini-css-extract-plugin
export var deliveryRow = "_s4-a";
export var fixedHeight = "_s4-4";
export var freightLogo = "_s4-9";
export var fullWidth = "_s4-3";
export var priceColumn = "_s4-5";
export var radioSelected = "_s4-7";
export var radioUnselected = "_s4-6";
export var selectedOption = "_s4-2";
export var selectedOptionContainer = "_s4-1";
export var selection = "_s4-0";
export var tallSkeletonText = "_s4-8";